<template>
  <pa-dialog
    :title="`${value.isExisting() ? $t('edit') : $t('create')} ${t$('resources._')}`"
    :subtitle="value.$.name"
    :positive-text="value.isExisting() ? $t('save') : $t('create')"
    negative-text
    :show="showDialog"
    :loading="value.saving"
    @positive="save()"
    @cancel="cancel()"
  >
    <v-flex xs12>
      <v-text-field
        v-model="value.name"
        :label="$t('name')"
        :error-messages="value.errors.name"
      />
    </v-flex>

    <!-- Custom Properties -->
    <v-flex
      v-for="customProp in customProperties(value.modelName.toLowerCase())"
      :key="`custom-prop-${customProp.id}`"
      xs12
      sm6
    >
      <pa-custom-property-field
        v-model="value[customProp.key]"
        :custom-prop="customProp"
      />
    </v-flex>

    <v-flex
      v-if="$can('organization')"
      xs12
      class="text-center"
    >
      <v-btn
        outlined
        small
        :to="{ name: 'organization-fields' }"
      >
        <v-icon left>
          add
        </v-icon>
        {{ $t('add') + ' ' + $t('customFields._') }}
      </v-btn>
    </v-flex>
  </pa-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

import Resource from '@/models/Resource'
import PaDialog from '@/components/shared/PaDialog'
import PaCustomPropertyField from '@/components/shared/PaCustomPropertyField'

export default {
  components: {
    PaDialog,
    PaCustomPropertyField
  },
  props: {
    value: {
      type: Resource,
      default: () => new Resource()
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('organizations', [ 'customProperties' ]),
    showDialog: {
      get () { return this.show },
      set (value) {
        if (!value) {
          this.$emit('update:show', false)
        }
      }
    }
  },
  methods: {
    async save () {
      this.value.organization = this.$currentOrganization.id

      const errors = await this.value.validate()
      if (Object.keys(errors).length) { return }

      await this.value.save()
      this.$emit('input', this.value)
      this.showDialog = false
    },
    cancel () {
      this.value.reset()
      this.showDialog = false
    }
  }
}
</script>

<style>

</style>
